<template>
    <div class="modal-overlay">
        <div
            :class="{ 'modals modals-center': true, show: true, 'modals-import new payment-modal': true }"
            v-on-clickaway="close"
            style="z-index:1000;"
        >
            <div class="modals-content">
                <div class="search-content">
                    <div class="modal-title">Your trial has ended</div>
                    <!--<p>
                        To keep using wplan please subscribe, it takes only a couple of minutes and costs
                        <span>4.99€/month</span>
                    </p>
                    -->
                    <div class="modals-footer">
                        <a :class="{ 'btn btn-default left save-btn': true }" @click="close">Cancel</a>
                        <!--
                        <a :class="{ 'btn btn-primary right save-btn': true }" @click="subscribe">Subscribe</a>
                        -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mixin as clickaway } from "vue-clickaway";
import { mapActions } from "vuex";
import router from "@/router";

export default {
    name: "trial-over-modal",
    props: ["shown"],
    mixins: [clickaway],
    mounted() {},
    computed: {},
    data() {
        return {};
    },
    methods: {
        close(ce) {
            this.$nextTick(() => {
                this.$emit("close-modal");
            });
        },
        subscribe() {
            this.close();
            router.push({ path: "/settings/subscription" });
        }
    }
};
</script>
<style scoped>
.modals-footer {
    margin-top: 16px;
}

.modal-overlay {
    position: fixed; /* Stay in place */
    z-index: 132; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.75); /* Black w/ opacity */
}

h2 {
    margin-bottom: 0rem;
    font-size: 1.6rem;
}

.modals-close {
    display: flex;
    margin-left: auto;
}

.modals-close a,
.modals-name {
    display: flex;
}

.modals-head {
    display: flex;
    border-bottom: 0.1rem solid #dbdbdb;
}

.modals-footer {
    display: flex;
    margin-bottom: 0px;
    justify-content: center;
}

.btn-default {
    margin-right: 1.2rem;
}

.btn-primary {
    margin-left: 1.2rem;
}

.modal-title {
    display: flex;
    justify-content: center;
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 2.4rem;
    margin-bottom: 1.6rem;
}

.search-content p {
    font-size: 1.2rem;
    line-height: 2.4rem;
    text-align: center;
    letter-spacing: 0.02em;
    margin-bottom: 3.2rem;
}
p span {
    font-weight: 500;
}
.modals {
    border-radius: 4px;
    background-color: #fefefe;
    margin: 15% auto; /* 15% from the top and centered */
    width: 40rem; /* Could be more or less, depending on screen size */
    max-width: 90%;
}

.modals-content {
    padding: 4rem;
}
</style>
